import { useMemo } from "react";
import { type TOptionsBase } from "i18next";
import { type $Dictionary } from "node_modules/i18next/typescript/helpers";
import { useTranslation } from "react-i18next";
import { Language } from "@/i18n";

export const useTranslationArray = (
  baseKey: string,
  options?: TOptionsBase & $Dictionary,
): string[] | undefined => {
  const { t, i18n } = useTranslation();

  const values = useMemo(() => {
    const result: string[] = [];

    let translationExists = true;
    let index = 0;

    while (translationExists) {
      if (i18n.exists(`${baseKey}.${index}`)) {
        result.push(t(`${baseKey}.${index}`, options));

        index++;
      } else {
        translationExists = false;
      }
    }

    if (result.length === 0 && i18n.language === (Language.DEV as string)) {
      result.push(baseKey);
    }

    return result;
  }, [t, i18n, baseKey, options]);

  return values.length > 0 ? values : undefined;
};
